// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { createContext, useContext } from 'react';
export const defaultValue = {
    isInlineToken: false,
};
export const TokenInlineContext = createContext(defaultValue);
export function useTokenInlineContext() {
    return useContext(TokenInlineContext);
}
//# sourceMappingURL=token-inline-context.js.map